import React from "react";
import {ReactHighcharts} from "../../../../../lib/react-highcharts";

export default ({viewTime}) => {
    if(!viewTime.length) return null;

    const viewsCount = viewTime.reduce((sum, i) => sum + i.count, 0);

    const chartConfig = {
        accessibility: {
            enabled: false,
        },
        credits: {enabled: false},
        title: {text: ''},
        xAxis: {
            type: 'category',
//            title: {text: ''}
        },
        yAxis: {
            title: {enabled: false}
        },
        legend: {
            enabled: false
        },
        tooltip: {
            formatter: function() {
                let percent = Math.round((this.y / viewsCount) * 10000)/100;
                let text = `<div>${this.key}</div>`;
                text += `<div><b style="color: ${this.color}">○</b> <strong>Зрителей</strong>: ${this.y} (${percent}%)</div>`;

                return text;
            },
            useHTML: true,
        },
        series: [{
            name: 'Зрителей',
            type: "column",
            colorByPoint: true,
            data: viewTime.map(i => [i.name + '%', i.count]),
//            events: {
//                click: async (e) => setClientWatchDuration(names[Object.keys(names)[e.point.index]])
//            }
        }]
    };

    return (
        <ReactHighcharts config={chartConfig} />
    );
};
